import gql from "graphql-tag";

export const GET_JOBS_COUNT_BY_RANGE = gql`
  query getJobCountByRange($startRange: Date!, $endRange: Date!) {
    getJobCountByRange(startRange: $startRange, endRange: $endRange)
  }
`;
